<article class="sidebar-container">
  <section class="header-container">
    <div class="header-row">
      <mds-icon
        [key]="icons.PERFORMANCE_ANALYTICS"
        [width]="24"
        [height]="24"
        class="button-icon icon-margin"
        [pathColors]="['#ffffff']"
      ></mds-icon>
      <p class="selection-text">{{ selectionText }}</p>
      <mds-icon
        [key]="icons.RIGHT_PANEL_CLOSE"
        [width]="24"
        [height]="24"
        class="button-icon icon-margin-right cursor-pointer"
        (click)="toggleSidePanel()"
      ></mds-icon>
    </div>

    <div class="title-section">
      <span class="main-title">Analytics on {{ appName }}</span>
      <span class="subtitle">{{ analyticsDataSummary?.unit }}</span>
    </div>

    <div class="total-section">
      <span class="total-label">Total</span>
      <div class="section-position">
        <span class="total-value">
          {{ totalDeltaValue?.replace('.', ',') }}
          <span class="unit">{{ analyticsDataSummary?.unit }}</span>
        </span>
        @if (analyticsDataSummary?.total_delta > 0) {
        <span class="change-percentage">{{ totalPercentage?.replace('.', ',') }}</span>
        } @if (analyticsDataSummary?.total_delta < 0) {
        <span class="change-percentage-positve">{{ totalPercentage?.replace('.', ',') }}</span>
        }
      </div>
    </div>
  </section>
</article>

<section class="main-section">
  @for (tools of contextualTools; track tools) {
  <div>
    @if (tools.list || tools.lines) {
    <accordion [collapsing]="true">
      <accordion-item [title]="tools.name" [expanded]="true">
        <ng-template accordionContent>
          @for (item of analyticsData; track item) {
          <div class="analytics-item">
            <div class="performance-percentage">
              <div #chartContainer id="doughnut-container" class="doughnut-container"></div>
              @if (item.delta < 0) {
              <span class="delta-positive">-{{ item.delta * -1 | formatNumber }}%</span>
              } @if (item.delta > 0) {
              <span class="delta-negative">{{ item.delta | formatNumber }}%</span>
              }
            </div>
            <div class="analytics-detail">
              <span>
                @if (!item.filtered.from.link) {
                <span>{{ item.filtered.from.name }}</span>
                } @if (item.filtered.from.link) {
                <a
                  [target]="'_blank'"
                  [href]="item.filtered.from.link.url | newUiRoute: true"
                  [attr.aria-label]="item.filtered.from.name"
                  class="from-link"
                  tabindex="0"
                >
                  {{ item.filtered.from.name }}
                </a>
                }
              </span>
              <strong class="switch-label">switched to</strong>
              <span>
                @if (!item.filtered.to.link) {
                <span>{{ item.filtered.to.name }}</span>
                } @if (item.filtered.to.link) {
                <a
                  [target]="'_blank'"
                  [href]="item.filtered.to.link.url | newUiRoute: true"
                  [attr.aria-label]="item.filtered.to.name"
                  class="to-link"
                  tabindex="0"
                >
                  {{ item.filtered.to.name }}
                </a>
                }
              </span>
            </div>
          </div>
          }
        </ng-template>
      </accordion-item>
    </accordion>
    }
  </div>
  }
</section>
